import * as dataActions from '@/data/data-actions';
import * as userSelectors from '@/user/user-selectors';
import { getPlaceSpecificUrl } from '@/utils/place-detection';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

export const useVerticalBarNavigation = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const { pathname } = useLocation();

  const place = useSelector(userSelectors.currentCity);

  const goToTab = useCallback(
    (targetPath) => {
      dispatch(dataActions.clearPropertyDetailsData());
      history.push(getPlaceSpecificUrl(place, targetPath));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, place]
  );

  return { goToTab, pathname };
};
